import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * One import process as a whole: which file it came from, when, and what is wrong with the file itself.
 * Everything about a single row lives on its strategy as a finding and is counted from there - see
 * `subscribeImportCounts`. Removed together with the last of its strategies, so the recent imports only
 * list processes that can still be opened.
 */
@Entity()
export class PersonImportStrategyValidation extends MongoEntity {
  public static override _class = 'PersonImportStrategyValidation';
  public static override _collectionName = 'person-import-strategy-validations';

  constructor(doc: PartialEntityData<PersonImportStrategyValidation>) {
    super(doc);
  }

  /**
   * When was the import process created. Used for automatic garbage collection per index
   */
  @Field(() => Date, { default: v => v ?? new Date() })
  createdAt!: Date;

  /**
   * There could be multiple import processes running at the same time.
   * This ID references the import process that this strategy belongs to.
   */
  @Field(() => ID)
  importProcessId: Maybe<string>;

  /** the name of the uploaded csv */
  @Field(() => String)
  fileName: Maybe<string>;

  /**
   * Column names in the csv which are not parsed by the import.
   * Can show syntax errors or other issues, if the user actually misstypes a column name.
   */
  @Field(() => [String])
  unusedFields: Maybe<string[]>;
}
